import { render, staticRenderFns } from "./myApp.vue?vue&type=template&id=b6431550&scoped=true"
import script from "./myApp.vue?vue&type=script&lang=js"
export * from "./myApp.vue?vue&type=script&lang=js"
import style0 from "./myApp.vue?vue&type=style&index=0&id=b6431550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6431550",
  null
  
)

export default component.exports